var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"padding-big display-flex flex-row justify-content-end bg-white-base w100"},[_c('BButton',{staticClass:"font-size-big margin-vertical-normal",attrs:{"link":"","color":"blue"},on:{"clickOrEnter":function () { return this$1.$router.go(-1); }}},[_vm._v(" Fechar visualização ")])],1),_c('main',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }